export default __webpack_public_path__ + "static/media/CurrentSensorsImg.7adc1399.jpg";